export default "__VITE_ASSET__74400cfe__"